import { colorStrings, mediaQueriesBP } from "@bevco/Utilities/variables";
import { RadioProps } from "@insite/mobius/Radio";
import { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

const radioWidth = 20;
const radioHeight = 20;

export const radio: RecursivePartial<{
    defaultProps?: FieldSetPresentationProps<RadioProps> | undefined;
    groupDefaultProps?: FieldSetGroupPresentationProps<RadioGroupProps> | undefined;
}> = {
    defaultProps: {
        color: colorStrings.commonGlobalWhite,
        mergeCss: true,
        css: css`
            &&& > input {
                border-color: ${getColor(colorStrings.commonGlobalGray01)};
                height: ${radioHeight}px;
                width: ${radioWidth}px;
                margin-right: 8px;

                &:focus {
                    border: 0;
                    & + ${TypographyStyle} {
                        &::before {
                            box-shadow: none;
                        }
                    }
                }

                /* When checked */
                &:checked:not(:disabled) {
                    & + ${TypographyStyle} {
                        font-weight: 700;
                        color: ${getColor(colorStrings.primaryMain)};
                        &::before {
                            border: 2px solid ${getColor(colorStrings.primaryMain)};
                            background-color: ${getColor(colorStrings.commonGlobalWhite)};
                            height: ${radioHeight}px;
                            width: ${radioWidth}px;
                        }

                        &::after {
                            background-color: ${getColor(colorStrings.primaryMain)};
                            height: ${radioHeight / 2}px;
                            width: ${radioWidth / 2}px;
                            left: ${radioWidth / 4}px;
                            top: calc(50% - ${radioWidth / 4}px);
                        }
                    }
                }

                /* When not checked */
                & + ${TypographyStyle} {
                    color: ${getColor(colorStrings.commonGlobalGray01)};
                    font-size: 14px;
                    line-height: 14px;
                    height: ${radioHeight}px;

                    &::before {
                        border-color: ${getColor(colorStrings.commonGlobalGray01)};
                        height: ${radioHeight}px;
                        width: ${radioWidth}px;
                    }

                    &::after {
                        background-color: ${getColor(colorStrings.commonGlobalWhite)};
                        height: ${radioHeight / 2}px;
                        width: ${radioWidth / 2}px;
                        left: 4px;
                        top: calc(50% - 4px);
                    }
                }
            }
        `,
    },
};
